import React, { useLayoutEffect } from "react"
import PropTypes from "prop-types";
import Immutable from "immutable";
import { connect } from "react-redux";
import { DEFAULT_PAGE_SIZE } from "../../../../config/constants";
import ModuleList from "../../../layout/ModuleList";
import { SEAT_MAP_ELEMENT_PATH, NEW_SEAT_MAP_ELEMENT_PATH } from "../../../../config/paths";
import { breadcrumbsPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import { SEAT_MAP_ELEMENT_COLUMN } from "../../../../config/columns";
import { clearSeatMapElements, getSeatMapElements } from "../../../../actions";

export const SeatMapElements = (
    {
  breadcrumbs,
  seatMapElements,
  loading,
  dispatchGetSeatMapElements,
  dispatchClearSeatMapElements,
}
) => {
    useLayoutEffect(()=>()=>dispatchClearSeatMapElements(), []);

    const data = seatMapElements.get('content') || [];
    const pages = seatMapElements.get('totalPages') || null;
    const defaultPageSize = seatMapElements.get('size') || DEFAULT_PAGE_SIZE;

    return (
    <ModuleList
        title="Elementos"
        breadcrumbs={breadcrumbs}
        buttonPath={NEW_SEAT_MAP_ELEMENT_PATH}
        tableStructure={{
        columns: SEAT_MAP_ELEMENT_COLUMN,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetSeatMapElements,
        modelPath: SEAT_MAP_ELEMENT_PATH,
        loading,
        navigateToModelOnRowClick: true,
        }}
    />
    ); 
}

const mapDispatchToProps = {
  dispatchGetSeatMapElements: getSeatMapElements,
  dispatchClearSeatMapElements: clearSeatMapElements,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Elementos',
      href: SEAT_MAP_ELEMENT_PATH,
    },
  ],
  seatMapElements: BusUnit.SeatMapElement.getIn(['all', 'content']),
  loading: BusUnit.SeatMapElement.getIn(['all', 'loading']),
});

SeatMapElements.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  seatMapElements: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetSeatMapElements: PropTypes.func.isRequired,
  dispatchClearSeatMapElements: PropTypes.func.isRequired,
};

SeatMapElements.defaultProps = {
  seatMapElements: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(SeatMapElements);